import { CompanyRiskScoreController } from '../controller/CompanyRiskScoreController';
import { BaseWidgetWebComponent } from '../../widget/BaseWidgetWebComponent';

export class CompanyRiskScoreWebComponent extends BaseWidgetWebComponent {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CompanyRiskScoreController,
    });
  }
}
